import $ from 'jquery';
import { modalTemplate } from './global-variables';

// eslint-disable-next-line no-undef
const ajaxObject = agObject;

const closeModal = () => {
    $('.ag-modal').remove();
    $('.ag-acc-popup').remove();
    $('body').removeClass('modal-active');
};

$('a[href$="#popup"]').on('click', (e) => {
    e.preventDefault();
    e.stopPropagation();

    $.ajax({
        url: ajaxObject.ajaxUrl,
        data: {
            nonce: ajaxObject.nonce,
            action: 'ag_do_popup_form',
        },
        beforeSend: () => {
            $('body').append(modalTemplate);
            $('body').addClass('modal-active');
        },
        success: (response) => {
            $('.ag-modal .ag-spinner').hide();
            $('.ag-modal .ag-modal-content').html(response.data.template);
        },
    });
});

$(document).on('click', '.ag-modal-close, .ag-modal-overlay', () => {
    closeModal();
});
